import { call, put } from 'redux-saga/effects'
// @ts-ignore
import req from '@sportninja/common/api/request'
import actions from '../actions/payment'
// @ts-ignore
import { generateSagas } from './utils'

const api = {
  fetchList: async (accountId: string) =>
    await req(`/account/${accountId}/payment-method`),
  createCard: async (accountId: string, stripePaymentId: string) =>
    await req(`/account/${accountId}/payment-method`, {
      method: 'POST',
      body: JSON.stringify({ payment_method_id: stripePaymentId }),
    }),
  updateDefault: async (accountId: string, paymentId: string) =>
    await req(`/account/${accountId}/payment-method`, {
      method: 'PUT',
      body: JSON.stringify({ payment_method_id: paymentId }),
    }),
  deleteMethod: async (accountId: string, paymentId: string) =>
    await req(`/account/${accountId}/payment-method`, {
      method: 'DELETE',
      body: JSON.stringify({ payment_method_id: paymentId }),
    }),
}

const paymentSagas = [
  [
    actions.fetchList,
    function* ({ accountId }: { accountId: string }) {
      const response = yield call(api.fetchList, accountId)
      yield put(actions.fetchList.success({ data: response?.data }))
      return response
    },
  ],
  [
    actions.createCard,
    function* ({
      accountId,
      stripePaymentId,
    }: {
      accountId: string
      stripePaymentId: string
    }) {
      yield call(api.createCard, accountId, stripePaymentId)
      // Re-fetch list after creation
      const response = yield call(api.fetchList, accountId)
      yield put(actions.createCard.success({ data: response?.data }))
      return response
    },
  ],
  [
    actions.updateDefault,
    function* ({
      accountId,
      paymentId,
    }: {
      accountId: string
      paymentId: string
    }) {
      yield call(api.updateDefault, accountId, paymentId)
      // Re-fetch list after update
      const response = yield call(api.fetchList, accountId)
      yield put(actions.updateDefault.success({ data: response?.data }))
      return response
    },
  ],
  [
    actions.deleteMethod,
    function* ({
      accountId,
      paymentId,
    }: {
      accountId: string
      paymentId: string
    }) {
      yield call(api.deleteMethod, accountId, paymentId)
      // Re-fetch list after deletion
      const response = yield call(api.fetchList, accountId)
      yield put(actions.deleteMethod.success({ data: response?.data }))
      return response
    },
  ],
]

export default generateSagas([...paymentSagas])
